import React from "react";
import PropTypes from "prop-types";

const getViewBox = (name) => {
  switch (name) {
    case "account":
      return "0 0 16 16";
    case "b2b":
      return "0 0 16 15";
    case "coordinator":
      return "0 0 20 20";
    case "customer_service":
      return "0 0 19 19";
    case "demo_classes":
      return "0 0 17.4 19.159";
    case "home":
      return "0 0 18 16";
    case "logout":
      return "0 0 14 15";
    case "notifications":
      return "0 0 16 17";
    case "whatsapp":
      return "0 0 26 26";
    case "plans":
      return "0 0 16 17";
    case "schedule":
      return "0 0 18 16";
    case "settings":
      return "0 0 16.5 16.5";
    case "rating":
      return "0 0 20 20";
    case "affiliate":
      return "2 0 19 19";
    case "content":
      return "0 0 25 25";
    case "report":
      return "0 0 36 34";
    case "students":
      return "0 0 20 20";
    case "contracts":
      return "0 0 18 22";
    case "teachers":
      return "0 0 19 16";
    case "order-detail":
      return "0 0 20.7 25.5";
    case "confirm":
      return "0 0 24 24";
    case "ico-change":
      return "0 0 12 13.578";
    case "review-pay":
      return "0 0 18.8 24";
    case "picture-placeholder":
      return "0 0 112 112";
    case "ico-camera":
      return "0 0 17.1 14.6";
    case "ico-arrow":
      return "0 0 6.75 12";
    case "ico-delete":
      return "0 0 12 12";
    default:
      return "0 0 32 32";
  }
};

const getPath = (name, props) => {
  switch (name) {
    case "account":
      return (
        <g transform="translate(-8 -8)">
          <g transform="translate(8 8)">
            <path
              {...props}
              d="M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8ZM12.44,21.8A3.768,3.768,0,0,1,16,18.22a3.767,3.767,0,0,1,3.56,3.58,6.837,6.837,0,0,1-7.12,0ZM16,16.3a1.562,1.562,0,0,1-1.56-1.56A1.545,1.545,0,0,1,16,13.2a1.562,1.562,0,0,1,1.56,1.56A1.545,1.545,0,0,1,16,16.3Zm4.66,4.66a5.041,5.041,0,0,0-3.4-3.76,2.754,2.754,0,1,0-4.02-2.44,2.732,2.732,0,0,0,1.5,2.44,5.009,5.009,0,0,0-3.4,3.76,6.8,6.8,0,1,1,9.32,0Z"
              transform="translate(-8 -8)"
            />
          </g>
        </g>
      );
    case "b2b":
      return (
        <g transform="translate(0 -5.061)">
          <g transform="translate(0 5.061)">
            <path
              {...props}
              d="M15.995,9.379a.5.5,0,0,0-.023-.227A1.7,1.7,0,0,0,14.3,7.727H11.754C11.606,5.865,10.46,5.061,8,5.061s-3.606.8-3.754,2.666H1.7A1.7,1.7,0,0,0,.028,9.152a.507.507,0,0,0-.023.227C0,9.4,0,9.412,0,9.429V17.74a1.7,1.7,0,0,0,1.7,1.7H14.3a1.7,1.7,0,0,0,1.7-1.7V9.429C16,9.412,16,9.4,15.995,9.379ZM8,6.4c2.066,0,2.379.561,2.427,1.332H5.572C5.62,6.956,5.934,6.4,8,6.4ZM1.7,8.728H14.3a.7.7,0,0,1,.67.5L13.61,11.6a1.8,1.8,0,0,1-1.365.79H9.722v-.262a1.1,1.1,0,0,0-1.1-1.1H7.379a1.1,1.1,0,0,0-1.1,1.1v.262H3.756A1.8,1.8,0,0,1,2.39,11.6L1.032,9.232A.7.7,0,0,1,1.7,8.728Zm7.019,3.4v1.853a.1.1,0,0,1-.1.1H7.379a.1.1,0,0,1-.1-.1V12.123a.1.1,0,0,1,.1-.1H8.621A.1.1,0,0,1,8.721,12.123ZM14.3,18.441H1.7a.7.7,0,0,1-.7-.7V11.186l.522.908a2.808,2.808,0,0,0,2.233,1.292H6.278v.59a1.1,1.1,0,0,0,1.1,1.1H8.621a1.1,1.1,0,0,0,1.1-1.1v-.59h2.522a2.808,2.808,0,0,0,2.233-1.292L15,11.186V17.74A.7.7,0,0,1,14.3,18.441Z"
              transform="translate(0 -5.061)"
            />
          </g>
        </g>
      );

    case "contracts":
      return (
        <g>
          <path
            {...props}
            d="M17.1,3.9l-3.3-3.3C13.4,0.3,12.9,0,12.4,0c0,0,0,0,0,0H2.3c-1.1,0-2,0.9-2,2v17.9c0,1.1,0.9,2,2,2h13.3
        c1.1,0,2-0.9,2-2V5.3C17.7,4.8,17.4,4.3,17.1,3.9z M13.7,2.8L14.9,4h-1.2V2.8z M15.7,20.3H2.3C2.1,20.3,2,20.2,2,20V2.1
        c0-0.2,0.2-0.4,0.4-0.4h9.7v3.1c0,0.4,0.4,0.8,0.8,0.8H16L16,20C16,20.2,15.9,20.3,15.7,20.3z"
          />
          <path
            {...props}
            d="M7,17.8C7,17.8,7,17.8,7,17.8H3.4c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0H7
        c0.3,0,0.6-0.3,0.6-0.6C7.6,18,7.4,17.8,7,17.8z"
          />
          <path
            {...props}
            d="M3.4,15.3h7.3c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H3.4c-0.3,0-0.6,0.3-0.6,0.6
        C2.8,15,3.1,15.3,3.4,15.3z"
          />
          <path
            {...props}
            d="M14.6,10.4H3.4c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h11.2c0.3,0,0.6-0.3,0.6-0.6
        C15.2,10.7,14.9,10.4,14.6,10.4z"
          />
          <path
            {...props}
            d="M14.6,6.7H3.4C3.1,6.7,2.8,7,2.8,7.3l0,0c0,0.3,0.3,0.6,0.6,0.6h11.2c0.3,0,0.6-0.3,0.6-0.6
        C15.2,7,14.9,6.7,14.6,6.7z"
          />
          <path
            {...props}
            d="M3.4,4.2h4.2c0.3,0,0.6-0.3,0.6-0.6S7.9,3.1,7.6,3.1H3.4c-0.3,0-0.6,0.3-0.6,0.6S3.1,4.2,3.4,4.2z"
          />
          <path
            {...props}
            d="M13.8,14.6C13.8,14.6,13.8,14.6,13.8,14.6l-3.2,3.2l-1.5-1.5c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l1.9,1.9
        c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l3.6-3.6c0.2-0.2,0.2-0.6,0-0.8C14.4,14.4,14.1,14.4,13.8,14.6z"
          />
        </g>
      );
    case "coordinator":
      return (
        <g>
          <path
            {...props}
            d="M8.919,10.215a.441.441,0,0,0,.388.23H10.93a.439.439,0,0,0,0-.878H9.477A4.532,4.532,0,0,1,8.919,10.215Z"
          />
          <path
            {...props}
            d="M11.367,7.965v0a.438.438,0,0,0-.438-.438h-.663a4.428,4.428,0,0,1-.2.878h.86A.439.439,0,0,0,11.367,7.965Z"
          />
          <polygon {...props} points="10.45 4.148 10.449 4.149 10.449 4.149 10.45 4.151 10.45 4.148" />
          <path
            {...props}
            d="M10.449,4.149a.667.667,0,0,0-1.319-.2,4.46,4.46,0,0,1,.558.758A.669.669,0,0,0,10.449,4.149Z"
          />
          <path
            {...props}
            d="M15.531,10.445h1.62a.439.439,0,0,0,0-.878h-1.62a.162.162,0,0,0-.044,0,.44.44,0,0,0,.044.878Z"
          />
          <path
            {...props}
            d="M14.047,7.525H12.411a.439.439,0,0,0,0,.878h1.626a.441.441,0,0,0,.44-.442V7.953A.43.43,0,0,0,14.047,7.525Z"
          />
          <path {...props} d="M15.531,8.4h1.622a.439.439,0,0,0,0-.878H15.531a.439.439,0,0,0,0,.878Z" />
          <path {...props} d="M17.341,4.054a.667.667,0,1,0-.667.667A.667.667,0,0,0,17.341,4.054Z" />
          <path
            {...props}
            d="M14.479,10.005V10a.43.43,0,0,0-.43-.43H12.414a.439.439,0,0,0,0,.878h1.628v0A.441.441,0,0,0,14.479,10.005Z"
          />
          <path
            {...props}
            d="M17.852,2.067H8.609a1.642,1.642,0,0,0-1.317.659,4.574,4.574,0,0,1,.831.393.766.766,0,0,1,.486-.172h9.243a.774.774,0,0,1,.775.771V5.189H9.932a4.509,4.509,0,0,1,.282.894h8.411v5.424a.773.773,0,0,1-.771.771H10.881a5.606,5.606,0,0,1,.6.88h6.364A1.656,1.656,0,0,0,19.5,11.51V3.718A1.655,1.655,0,0,0,17.852,2.067Z"
          />
          <path
            {...props}
            d="M8.753,11.59A4.649,4.649,0,0,0,6.5,11.01H5.112A4.626,4.626,0,0,0,.5,15.619v.657a1.66,1.66,0,0,0,1.658,1.656H9.432A1.664,1.664,0,0,0,11.086,16.3V15.39a4.6,4.6,0,0,0-1.609-3.284A6.428,6.428,0,0,0,8.753,11.59Zm1.219,4.029v.657a.537.537,0,0,1-.537.538H2.161a.538.538,0,0,1-.539-.538v-.657a3.5,3.5,0,0,1,3.493-3.494H6.5a3.5,3.5,0,0,1,3.468,3.494Z"
          />
          <path
            {...props}
            d="M5.8,10.681h0A3.707,3.707,0,1,0,2.094,6.974,3.706,3.706,0,0,0,5.8,10.681Zm0-6.348h0v0A2.647,2.647,0,1,1,3.156,6.981,2.649,2.649,0,0,1,5.8,4.328Z"
          />
        </g>
      );
    case "customer_service":
      return (
        <g>
          <path
            {...props}
            d="M13.4,2.7c-1-0.5-2.1-0.7-3.2-0.7C5.9,2,2.5,5.5,2.5,9.8c0,1.1,0.2,2.2,0.7,3.2L2,17c-0.1,0.4,0.1,0.8,0.5,0.9
          c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0L7,16.8c3.9,1.8,8.5,0,10.3-3.9S17.3,4.5,13.4,2.7z M14.7,14.2L14.7,14.2
          c-1.9,1.9-4.8,2.4-7.2,1.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
          l-3.1,0.9l0.9-3.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1
          c0,0,0,0,0,0C3.1,9.5,4.3,5.7,7.4,4.2c0.9-0.4,1.8-0.7,2.8-0.7c3.5,0,6.3,2.8,6.3,6.3C16.5,11.4,15.8,13,14.7,14.2z"
          />
          <path
            {...props}
            d="M9.7,12.4H9.6c-0.2,0-0.4,0.1-0.5,0.2s-0.2,0.3-0.2,0.5v0.2c0,0.2,0.1,0.4,0.2,0.5S9.3,14,9.6,14h0.2
          c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-0.2c0-0.2-0.1-0.4-0.2-0.5C10.1,12.4,9.9,12.4,9.7,12.4z"
          />
          <path
            {...props}
            d="M11.3,5.5c-0.4-0.2-0.9-0.4-1.5-0.4C9.4,5.1,9,5.2,8.6,5.4s-0.7,0.4-1,0.7C7.4,6.2,7.4,6.4,7.4,6.6
          c0,0.2,0.1,0.4,0.3,0.6c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.3C9,6.7,9.4,6.6,9.9,6.6c0.4,0,0.8,0.1,1.1,0.4s0.4,0.6,0.4,1
          c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.2-0.7,0.4-1.3,0.4c-0.2,0-0.4,0.1-0.5,0.2C9,9.8,8.9,10,8.9,10.2v0.9c0,0.2,0.1,0.4,0.2,0.5
          c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-0.4c0,0,0,0,0.1-0.1c0.7-0.1,1.3-0.4,1.8-0.8
          c0.4-0.4,0.7-1.1,0.7-1.8c0-0.5-0.1-1-0.4-1.4C12.1,6.1,11.8,5.7,11.3,5.5z"
          />
        </g>
      );
    case "demo_classes":
      return (
        <g transform="translate(-2.3 -0.8)">
          <g transform="translate(2.5 1)">
            <path
              {...props}
              d="M5.431,15.655h13.19a.879.879,0,0,0,.879-.879V1.879A.879.879,0,0,0,18.621,1H5.431A2.934,2.934,0,0,0,2.5,3.931v12.9a2.934,2.934,0,0,0,2.931,2.931h13.19a.879.879,0,1,0,0-1.759H5.431a1.172,1.172,0,0,1,0-2.345ZM4.259,3.931A1.174,1.174,0,0,1,5.431,2.759h12.31V13.9H5.431a2.9,2.9,0,0,0-1.172.249Z"
              transform="translate(-2.5 -1)"
            />
            <path
              {...props}
              d="M331.542,335.623c-.014.016-.019.036-.034.051a.918.918,0,0,1-1,.2.939.939,0,0,1-.343-.214.91.91,0,0,1-.056-.085l-1.849-1.848a.92.92,0,1,1,1.3-1.3l1.247,1.247,4.064-4.064a.951.951,0,1,1,1.344,1.345Z"
              transform="translate(-323.22 -325.792)"
            />
          </g>
        </g>
      );
    case "home":
      return (
        <g transform="translate(-1.046 -6.975)">
          <path
            {...props}
            d="M19.023,14.01,10.56,7.128a.622.622,0,0,0-.818,0L1.3,14.01a.61.61,0,0,0-.2.725.626.626,0,0,0,.614.428H4.088v7.161a.659.659,0,0,0,.651.651H15.582a.659.659,0,0,0,.651-.651V15.163h2.381a.643.643,0,0,0,.614-.428A.684.684,0,0,0,19.023,14.01Zm-7.849,4.52v3.162H9.128V18.53Zm.651-1.3H8.477a.659.659,0,0,0-.651.651v3.813H5.371V14.531a.659.659,0,0,0-.651-.651H3.511l6.64-5.394,6.64,5.394H15.582a.659.659,0,0,0-.651.651v7.161H12.476V17.879A.647.647,0,0,0,11.825,17.228Z"
            transform="translate(0)"
          />
        </g>
      );
    case "logout":
      return (
        <g transform="translate(-1.01)">
          <path
            {...props}
            d="M8,0a1.078,1.078,0,0,0-.95,1V7a.951.951,0,1,0,1.9,0V1A.967.967,0,0,0,8,0ZM4.656,2.5a.952.952,0,0,0-.25.094,6.3,6.3,0,0,0-3.125,7.469A6.907,6.907,0,0,0,7.969,15a6.954,6.954,0,0,0,6.719-4.781,6.424,6.424,0,0,0-3.125-7.594,1,1,0,0,0-1.313.344,1,1,0,0,0,.344,1.313,4.382,4.382,0,0,1,2.281,5.375,4.972,4.972,0,0,1-4.906,3.437A4.95,4.95,0,0,1,3.094,9.5,4.226,4.226,0,0,1,5.281,4.281a.98.98,0,0,0,.456-1.106A.98.98,0,0,0,4.75,2.5q-.047,0-.094,0Z"
          />
        </g>
      );
    case "notifications":
      return (
        <g transform="translate(-23.5 -22)">
          <g transform="translate(23.5 22)">
            <g transform="translate(0 0)">
              <path
                {...props}
                d="M28.632,36.038h1.509a1.358,1.358,0,1,0,2.717,0h1.509a2.868,2.868,0,1,1-5.736,0ZM39.5,33.924v.3a1.357,1.357,0,0,1-1.359,1.358H24.859A1.358,1.358,0,0,1,23.5,34.227v-.3a2.266,2.266,0,0,1,1.811-2.218V28.188a6.189,6.189,0,0,1,12.377,0v3.518A2.263,2.263,0,0,1,39.5,33.924Zm-1.509,0a.754.754,0,0,0-.758-.754,1.056,1.056,0,0,1-1.054-1.054V28.188a4.679,4.679,0,0,0-9.358,0v3.927a1.056,1.056,0,0,1-1.054,1.054.756.756,0,0,0-.758.754v.151H37.991Z"
                transform="translate(-23.5 -22)"
              />
            </g>
          </g>
        </g>
      );
    case "whatsapp":
      return (
        <path
          {...props}
          d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
        />
      );
    case "plans":
      return (
        <g>
          <path
            {...props}
            d="M16.4,9.345v-.7h-2.22a9.736,9.736,0,0,0-.737-3.461A7.724,7.724,0,0,0,14.64,4.15l-.511-.481a7.222,7.222,0,0,1-.988.867A4.916,4.916,0,0,0,8.985,1.582,4.916,4.916,0,0,0,4.831,4.536a7.156,7.156,0,0,1-.988-.867l-.511.481A7.721,7.721,0,0,0,4.524,5.181a9.744,9.744,0,0,0-.737,3.461H1.573v.7H3.787a9.74,9.74,0,0,0,.728,3.44,7.743,7.743,0,0,0-1.2,1.04l.512.48a7.189,7.189,0,0,1,.991-.873,4.923,4.923,0,0,0,4.165,2.974,4.925,4.925,0,0,0,4.166-2.974,7.186,7.186,0,0,1,.991.873l.513-.48a7.761,7.761,0,0,0-1.2-1.04,9.738,9.738,0,0,0,.728-3.44Zm-2.928-.7H11.393a23.08,23.08,0,0,0-.155-2.389,7.8,7.8,0,0,0,1.613-.7A9.241,9.241,0,0,1,13.476,8.643ZM8.985,15.736c-.49,0-1.135-1.306-1.476-3.512a7.169,7.169,0,0,1,2.951,0C10.121,14.431,9.476,15.736,8.985,15.736Zm0-4.367a7.725,7.725,0,0,0-1.568.162c-.076-.664-.125-1.395-.136-2.185h3.407c-.012.79-.059,1.521-.136,2.185A7.717,7.717,0,0,0,8.985,11.369Zm-1.7-2.726A21.965,21.965,0,0,1,7.42,6.431a7.7,7.7,0,0,0,1.565.161,7.7,7.7,0,0,0,1.565-.161,21.967,21.967,0,0,1,.139,2.212Zm1.7-6.391c.489,0,1.131,1.295,1.472,3.485a7.153,7.153,0,0,1-1.472.153,7.156,7.156,0,0,1-1.472-.153C7.855,3.547,8.5,2.252,8.985,2.252Zm3.577,2.664a6.91,6.91,0,0,1-1.42.642,9.228,9.228,0,0,0-.923-3.041A4.969,4.969,0,0,1,12.562,4.916Zm-4.811-2.4a9.226,9.226,0,0,0-.922,3.041,6.913,6.913,0,0,1-1.42-.642A4.97,4.97,0,0,1,7.751,2.516ZM5.119,5.557a7.811,7.811,0,0,0,1.613.7,23.178,23.178,0,0,0-.155,2.389H4.495A9.237,9.237,0,0,1,5.119,5.557ZM4.495,9.345H6.577a23.131,23.131,0,0,0,.152,2.363,7.807,7.807,0,0,0-1.619.7A9.261,9.261,0,0,1,4.495,9.345Zm.9,3.705A6.937,6.937,0,0,1,6.824,12.4a9.281,9.281,0,0,0,.926,3.068A4.981,4.981,0,0,1,5.4,13.05Zm4.822,2.421a9.269,9.269,0,0,0,.927-3.068,6.889,6.889,0,0,1,1.427.647A4.98,4.98,0,0,1,10.22,15.472Zm2.641-3.063a7.812,7.812,0,0,0-1.619-.7,23.028,23.028,0,0,0,.151-2.363h2.083A9.257,9.257,0,0,1,12.861,12.409Z"
            transform="translate(-0.988 -0.994)"
          />
          <path
            {...props}
            d="M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,.8A7.2,7.2,0,1,0,15.2,8,7.211,7.211,0,0,0,8,.8Z"
          />
        </g>
      );
    case "schedule":
      return (
        <g transform="translate(-8.6 -13.4)">
          <path
            {...props}
            d="M24.316,13.4H10.983A2.388,2.388,0,0,0,8.6,15.783V27.017A2.388,2.388,0,0,0,10.983,29.4H24.316A2.388,2.388,0,0,0,26.7,27.017V15.783A2.388,2.388,0,0,0,24.316,13.4ZM10.983,14.668H24.316a1.119,1.119,0,0,1,1.115,1.115V17.9H9.868v-2.12A1.119,1.119,0,0,1,10.983,14.668ZM24.316,28.132H10.983a1.119,1.119,0,0,1-1.115-1.115V19.192H25.431v7.825A1.119,1.119,0,0,1,24.316,28.132Z"
            transform="translate(0)"
          />
          <path
            {...props}
            d="M24.173,49.4H21.834a.634.634,0,1,0,0,1.268h2.339a.634.634,0,1,0,0-1.268Z"
            transform="translate(-9.846 -28.131)"
          />
        </g>
      );
    case "settings":
      return (
        <g transform="translate(0.251 0.252)">
          <path
            {...props}
            style={{ strokeWidth: "0.5px" }}
            d="M15.286,6.453c-.3-.045-.61-.088-.918-.128a.09.09,0,0,1-.077-.064,6.493,6.493,0,0,0-.614-1.481.091.091,0,0,1,.009-.1c.189-.246.377-.5.558-.74a.844.844,0,0,0-.082-1.091L13.15,1.836a.844.844,0,0,0-1.091-.082c-.244.181-.493.368-.74.558a.091.091,0,0,1-.1.009,6.506,6.506,0,0,0-1.481-.614.091.091,0,0,1-.064-.077c-.04-.309-.083-.618-.128-.918A.843.843,0,0,0,8.714,0H7.284a.843.843,0,0,0-.83.713c-.045.3-.088.609-.128.918a.09.09,0,0,1-.064.077A6.477,6.477,0,0,0,4.78,2.32a.092.092,0,0,1-.1-.009c-.247-.19-.5-.378-.74-.559a.844.844,0,0,0-1.091.082L1.836,2.847a.844.844,0,0,0-.082,1.091c.181.245.369.494.558.74a.091.091,0,0,1,.009.1A6.493,6.493,0,0,0,1.707,6.26a.091.091,0,0,1-.077.064c-.308.04-.617.083-.918.128A.843.843,0,0,0,0,7.283v1.43a.843.843,0,0,0,.713.83c.3.045.61.088.918.128a.09.09,0,0,1,.077.064,6.493,6.493,0,0,0,.614,1.481.091.091,0,0,1-.009.1c-.19.246-.378.5-.558.74a.844.844,0,0,0,.082,1.091l1.011,1.011a.844.844,0,0,0,1.091.082c.244-.181.493-.368.74-.558a.091.091,0,0,1,.1-.009,6.506,6.506,0,0,0,1.481.614.091.091,0,0,1,.064.077c.04.309.083.618.128.918a.843.843,0,0,0,.83.713h1.43a.843.843,0,0,0,.83-.713c.045-.3.088-.609.128-.918a.091.091,0,0,1,.064-.077,6.477,6.477,0,0,0,1.481-.614.092.092,0,0,1,.1.009c.247.19.5.378.74.558a.844.844,0,0,0,1.091-.082l1.011-1.011a.844.844,0,0,0,.082-1.091c-.181-.245-.369-.494-.558-.74a.091.091,0,0,1-.009-.1,6.5,6.5,0,0,0,.614-1.481.09.09,0,0,1,.077-.064c.308-.04.617-.083.918-.128A.843.843,0,0,0,16,8.713V7.283a.843.843,0,0,0-.713-.83Zm-.034,2.26a.092.092,0,0,1-.077.091c-.3.044-.6.087-.9.126a.836.836,0,0,0-.7.607,5.751,5.751,0,0,1-.543,1.31.837.837,0,0,0,.066.925c.187.243.372.488.55.729a.092.092,0,0,1-.01.118l-1.011,1.011a.092.092,0,0,1-.118.01c-.24-.178-.486-.363-.729-.55a.836.836,0,0,0-.925-.066,5.746,5.746,0,0,1-1.31.543.837.837,0,0,0-.607.7c-.04.3-.082.608-.126.9a.092.092,0,0,1-.091.077H7.283a.092.092,0,0,1-.091-.077c-.044-.3-.087-.6-.126-.9a.836.836,0,0,0-.607-.7,5.758,5.758,0,0,1-1.31-.543.837.837,0,0,0-.925.066c-.243.187-.488.372-.729.55a.091.091,0,0,1-.118-.01L2.364,12.622a.091.091,0,0,1-.01-.118c.178-.241.363-.486.55-.729a.836.836,0,0,0,.066-.925,5.751,5.751,0,0,1-.543-1.31.837.837,0,0,0-.7-.607c-.3-.04-.608-.082-.9-.126a.092.092,0,0,1-.077-.091V7.284a.092.092,0,0,1,.077-.091c.3-.044.6-.087.9-.126a.836.836,0,0,0,.7-.607,5.74,5.74,0,0,1,.543-1.31A.837.837,0,0,0,2.9,4.224c-.186-.242-.371-.487-.55-.729a.092.092,0,0,1,.01-.118L3.375,2.365a.092.092,0,0,1,.118-.01c.24.178.486.363.729.55a.836.836,0,0,0,.925.066,5.742,5.742,0,0,1,1.31-.543.837.837,0,0,0,.607-.7c.04-.3.082-.608.126-.9A.092.092,0,0,1,7.283.746h1.43A.092.092,0,0,1,8.8.823c.044.3.087.6.126.9a.836.836,0,0,0,.607.7,5.758,5.758,0,0,1,1.31.543.837.837,0,0,0,.925-.066c.243-.187.488-.372.729-.55a.092.092,0,0,1,.118.01l1.011,1.011a.092.092,0,0,1,.01.118c-.178.241-.363.486-.55.729a.836.836,0,0,0-.066.925,5.746,5.746,0,0,1,.543,1.31.836.836,0,0,0,.7.607c.3.04.608.082.9.126a.092.092,0,0,1,.077.091v1.43Z"
          />
          <path
            {...props}
            style={{ strokeWidth: "0.5px" }}
            d="M18.321,14.676a3.645,3.645,0,1,0,3.644,3.645A3.65,3.65,0,0,0,18.321,14.676Zm0,.657a2.987,2.987,0,1,1-2.987,2.987,2.982,2.982,0,0,1,2.987-2.987Z"
            transform="translate(-10.322 -10.322)"
          />
        </g>
      );
    case "students":
      return (
        <g>
          <path
            {...props}
            style={{ strokeWidth: "0.5px" }}
            d="M14.433,9.293H13.052a4.67,4.67,0,0,0-3.9,2.091,4.693,4.693,0,0,0-2.162-.53H5.567A4.722,4.722,0,0,0,.85,15.565v.672a1.711,1.711,0,0,0,1.709,1.709h7.4a1.718,1.718,0,0,0,1.7-1.537h5.784A1.711,1.711,0,0,0,19.15,14.7v-.692A4.723,4.723,0,0,0,14.433,9.293ZM10.47,16.237a.518.518,0,0,1-.518.518h-7.4a.518.518,0,0,1-.518-.518v-.668A3.53,3.53,0,0,1,5.56,12.043H6.966a3.535,3.535,0,0,1,3.5,3.526Zm7.485-1.558a.519.519,0,0,1-.518.518H11.656a4.716,4.716,0,0,0-1.546-3.131,3.524,3.524,0,0,1,2.93-1.582h1.411a3.536,3.536,0,0,1,3.5,3.527Z"
          />
          <path
            {...props}
            style={{ strokeWidth: "0.5px" }}
            d="M6.257,10.373a3.38,3.38,0,1,0-3.38-3.38A3.384,3.384,0,0,0,6.257,10.373ZM6.241,4.937h.022a2.178,2.178,0,0,1-.01,4.356H6.242A2.178,2.178,0,0,1,4.074,7.105,2.186,2.186,0,0,1,6.241,4.937Z"
          />
          <path
            {...props}
            style={{ strokeWidth: "0.5px" }}
            d="M13.742,8.813a3.38,3.38,0,1,0-3.38-3.379A3.383,3.383,0,0,0,13.742,8.813Zm-.011-5.406h.021a2.178,2.178,0,0,1-.01,4.356h-.01a2.178,2.178,0,0,1,0-4.356Z"
          />
        </g>
      );
    case "teachers":
      return (
        <g>
          <g transform="translate(9.095 2.914)">
            <path
              {...props}
              d="M19.053,4.606H12.393a.378.378,0,0,1,0-.757h6.659a.378.378,0,1,1,0,.757Z"
              transform="translate(-12.015 -3.849)"
            />
          </g>
          <g transform="translate(9.096 4.92)">
            <path
              {...props}
              d="M16.167,7.257H12.394a.378.378,0,0,1,0-.757h3.773a.378.378,0,0,1,0,.757Z"
              transform="translate(-12.016 -6.5)"
            />
          </g>
          <g transform="translate(9.095 6.927)">
            <path
              {...props}
              d="M17.539,9.908H12.393a.378.378,0,0,1,0-.757h5.145a.378.378,0,0,1,0,.757Z"
              transform="translate(-12.015 -9.151)"
            />
          </g>
          <path
            {...props}
            d="M20.055,0H6.663a.455.455,0,0,0-.454.454V1.762c.076,0,.147-.023.223-.023a3.841,3.841,0,0,1,.684.069v-.9H19.6V9.6H9.485a6.535,6.535,0,0,1,.609.444,4.491,4.491,0,0,1,.466.464h9.495a.455.455,0,0,0,.454-.454V.454A.455.455,0,0,0,20.055,0Z"
            transform="translate(-1.509)"
          />
          <path
            {...props}
            d="M9.841,16.374a4.28,4.28,0,0,0-1.5-3.055,6.1,6.1,0,0,0-.672-.48A4.332,4.332,0,0,0,5.571,12.3H4.284A4.3,4.3,0,0,0,0,16.584v.611a1.542,1.542,0,0,0,1.54,1.54H8.3a1.549,1.549,0,0,0,1.537-1.518v-.843Zm-1.039.21v.611a.5.5,0,0,1-.5.5H1.54a.5.5,0,0,1-.5-.5v-.611a3.252,3.252,0,0,1,3.247-3.247l.07,0H5.577A3.255,3.255,0,0,1,8.8,16.584Z"
            transform="translate(0 -2.988)"
          />
          <path
            {...props}
            d="M5.4,9.686A3.445,3.445,0,1,0,1.954,6.241,3.449,3.449,0,0,0,5.4,9.686Zm0-5.9a2.46,2.46,0,1,1-2.46,2.46A2.463,2.463,0,0,1,5.4,3.782Z"
            transform="translate(-0.475 -0.68)"
          />
        </g>
      );
    case "order-details":
      return (
        <g>
          <path
            {...props}
            d="M13.8,5.2C13.8,5.2,13.8,5.2,13.8,5.2H4.6c-0.3,0-0.6,0.2-0.6,0.6s0.2,0.6,0.6,0.6h9.2c0.3,0,0.6-0.2,0.6-0.6
          S14.2,5.2,13.8,5.2z"
          />
          <path
            {...props}
            d="M13.8,7.8H4.6C4.3,7.8,4.1,8,4.1,8.3s0.2,0.6,0.6,0.6h9.2c0.3,0,0.6-0.2,0.6-0.6S14.2,7.8,13.8,7.8z"
          />
          <path
            {...props}
            d="M13.8,10.3H4.6c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.2,0.6,0.6,0.6h9.2c0.3,0,0.5-0.3,0.6-0.6
          C14.4,10.6,14.1,10.3,13.8,10.3z"
          />
          <path
            {...props}
            d="M10.9,14c0.3,0,0.6-0.2,0.6-0.6s-0.2-0.6-0.6-0.6H4.6c-0.3,0-0.6,0.2-0.6,0.6S4.3,14,4.6,14H10.9z"
          />
          <path
            {...props}
            d="M1.1,23V1.2h16.6V14c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.8,0.1V0.6c0-0.3-0.3-0.5-0.6-0.6H0.6C0.3,0,0,0.3,0,0.6
          v22.9C0,23.7,0.3,24,0.6,24h13c-0.3-0.3-0.5-0.7-0.8-1H1.1z"
          />
          <path
            {...props}
            d="M20.2,20.5c-0.3-0.3-0.9-0.6-1.6-0.8v-2.4c0.2,0.1,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.2,0.5,0.4
          c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.4-0.2s0.1-0.2,0.1-0.4c0-0.2-0.1-0.3-0.3-0.5c-0.2-0.2-0.4-0.4-0.7-0.5
          c-0.3-0.1-0.6-0.2-1-0.3v-0.6c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1s-0.2,0.2-0.2,0.4v0.6
          c-0.7,0.1-1.2,0.3-1.6,0.7c-0.4,0.4-0.6,0.9-0.6,1.4c0,0.6,0.2,1.1,0.6,1.4c0.4,0.3,0.9,0.6,1.6,0.8v2.5c-0.3,0-0.6-0.1-0.8-0.3
          c-0.3-0.1-0.5-0.3-0.7-0.5c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.3,0.1-0.4,0.2s-0.2,0.2-0.2,0.4c0,0.2,0.1,0.3,0.2,0.5
          c0.3,0.3,0.6,0.5,1,0.7c0.3,0.1,0.7,0.2,1.2,0.3V25c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.3,0,0.4-0.1
          c0.1-0.1,0.1-0.2,0.1-0.4v-0.9c0.6-0.1,1.1-0.4,1.5-0.7s0.6-0.8,0.6-1.4C20.7,21.3,20.6,20.8,20.2,20.5z M17.6,19.5
          c-0.4-0.1-0.6-0.3-0.8-0.4c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.5-0.3,0.8-0.4V19.5z M19.4,22.6
          c-0.2,0.2-0.4,0.3-0.7,0.4v-2.2c0.3,0.1,0.6,0.3,0.8,0.5c0.2,0.2,0.3,0.4,0.3,0.7C19.7,22.2,19.6,22.4,19.4,22.6z"
          />
        </g>
      );
    case "ico-change":
      return (
        <g transform="translate(-1104.73 -193.725)">
          <g id="Group_3120" data-name="Group 3120" transform="translate(1116.73 201.304) rotate(180)">
            <path {...props} d="M0,1.072H5.357V0H0V1.072Z" transform="translate(0.758 3.033) rotate(45)" />
            <path {...props} d="M0,1.072H9.57V0H0V1.072Z" transform="translate(0.756 3.253)" />
            <path {...props} d="M0,1.072H5.356V0H0V1.072Z" transform="translate(0 3.787) rotate(-45)" />
          </g>
          <g id="Group_3121" data-name="Group 3121" transform="translate(1104.73 199.724)">
            <path {...props} d="M0,1.072H5.357V0H0V1.072Z" transform="translate(0.758 3.033) rotate(45)" />
            <path {...props} d="M3,17.072h9.57V16H3v1.072Z" transform="translate(-2.244 -12.747)" />
            <path {...props} d="M0,1.072H5.356V0H0V1.072Z" transform="translate(0 3.787) rotate(-45)" />
          </g>
        </g>
      );
    case "confirm":
      return (
        <g>
          <path
            {...props}
            d="M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M12,22.5
          C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z"
          />
          <path
            {...props}
            d="M16.7,7.4l-6.4,6.4l-3-2.9c-0.5-0.5-1.4-0.5-1.9,0s-0.5,1.4,0,1.9l4,3.9C9.6,16.9,10,17,10.3,17
          c0.4,0,0.7-0.1,0.9-0.4l7.4-7.4c0.5-0.5,0.5-1.4,0-1.9C18.1,6.9,17.3,6.9,16.7,7.4z"
          />
        </g>
      );
    case "review-pay":
      return (
        <g>
          <path
            {...props}
            d="M18.3,15.9c0.3,0,0.5-0.3,0.6-0.6V0.6c0-0.3-0.3-0.5-0.6-0.6H0.6C0.3,0,0,0.3,0,0.6v22.9C0,23.7,0.3,24,0.6,24
          h13.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l4.4-4.4c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.2
          c-0.1-0.1-0.1-0.3-0.3-0.3c-0.1,0-0.1,0-0.2,0h-4.4c-0.3,0-0.5,0.3-0.6,0.6V23H1.1V1.2h16.6v14.1C17.7,15.6,18,15.9,18.3,15.9z
            M14.4,19.6h2.5l-2.5,2.5V19.6z"
          />
          <path
            {...props}
            d="M13.8,5.2C13.8,5.2,13.8,5.2,13.8,5.2H4.6c-0.3,0-0.6,0.2-0.6,0.6s0.2,0.6,0.6,0.6h9.2c0.3,0,0.6-0.2,0.6-0.6
          S14.2,5.2,13.8,5.2z"
          />
          <path
            {...props}
            d="M13.8,7.8H4.6C4.3,7.8,4.1,8,4.1,8.3s0.2,0.6,0.6,0.6h9.2c0.3,0,0.6-0.2,0.6-0.6S14.2,7.8,13.8,7.8z"
          />
          <path
            {...props}
            d="M14.4,10.9c0-0.3-0.3-0.5-0.6-0.6H4.6c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.2,0.6,0.6,0.6h9.2
          C14.1,11.4,14.4,11.2,14.4,10.9z"
          />
          <path
            {...props}
            d="M4.6,12.9c-0.3,0-0.6,0.2-0.6,0.6S4.3,14,4.6,14h6.3c0.3,0,0.6-0.2,0.6-0.6s-0.2-0.6-0.6-0.6H4.6z"
          />
        </g>
      );
    case "picture-placeholder":
      return (
        <g>
          <path
            {...props}
            d="M104.585,90.075h0c-.044,0-.066-.022-.088-.022s-.066-.022-.088-.022h0l-.11-.022c-.331-2.6-1.323-4.872-3.506-6.063v.176a14.117,14.117,0,0,0-.485-3.594,38.215,38.215,0,0,0,3.836-5.843c2.117.353,4.939-1.5,6.791-4.586,2.2-3.616,2.293-7.672,0-8.907a2.458,2.458,0,0,0-.926-.353,25.848,25.848,0,0,0,1.543-10.583l.882,3.528c2.381-15.874-13.581-21.959-13.581-21.959,1.676-.176,4.409,1.323,4.409,1.323-7.43-8.488-19.534-3.175-19.754-3.087,3.969-3.373,7.54-3.2,7.827-3.175-17.528-2.646-20.526,7.849-20.526,7.849a6.539,6.539,0,0,1-.706-3.88c-1.213,2.072.044,6.173.088,6.35-1.235-3.087-5.556-2.557-5.556-2.557,3.7.617,4.321,2.91,4.321,2.91C59.7,41,61.284,50.611,61.284,50.611l2.2-2.646A20.492,20.492,0,0,0,64.415,60.8l-.132.066h0a2.758,2.758,0,0,0-1.676.353c-2.117,1.323-2.028,5.291.176,8.907,1.852,3.087,4.674,4.85,6.791,4.586a39.426,39.426,0,0,0,3.858,5.843,18.1,18.1,0,0,0-.507,3.594v.2a1.63,1.63,0,0,1,0-.375c-2.183,1.213-3.175,3.483-3.483,6.129C60.755,92.324,47.7,98.674,39.7,106.7a56.027,56.027,0,0,0,94.539-.044C126.169,98.828,113.183,92.28,104.585,90.075Z"
            transform="translate(-30.947 -20.626)"
          />
        </g>
      );
    case "ico-camera":
      return (
        <g transform="translate(-6.9 -13.5)">
          <path
            {...props}
            d="M24,18.2A2.22,2.22,0,0,0,21.8,16H19.6l-.2-.8a2.14,2.14,0,0,0-2.1-1.7H13.5a2.14,2.14,0,0,0-2.1,1.7l-.2.8H9.1a2.22,2.22,0,0,0-2.2,2.2v7.7a2.22,2.22,0,0,0,2.2,2.2H21.8A2.22,2.22,0,0,0,24,25.9Zm-1.3,0v7.7a.9.9,0,0,1-.9.9H9.1a.9.9,0,0,1-.9-.9V18.2a.9.9,0,0,1,.9-.9h2.6a.634.634,0,0,0,.6-.5l.3-1.3a.961.961,0,0,1,.9-.7h3.8a.961.961,0,0,1,.9.7l.3,1.3a.634.634,0,0,0,.6.5h2.6A.923.923,0,0,1,22.7,18.2Z"
          />
          <path
            {...props}
            d="M15.4,17.3a4.3,4.3,0,1,0,4.3,4.3A4.207,4.207,0,0,0,15.4,17.3Zm3.1,4.3a3,3,0,1,1-3-3A3.009,3.009,0,0,1,18.5,21.6Z"
          />
        </g>
      );

    case "ico-arrow":
      return (
        <g>
          <path
            {...props}
            d="M7,16a.681.681,0,0,1-.525-.225l-5.25-5.25a.725.725,0,0,1,0-1.05l5.25-5.25a.742.742,0,1,1,1.05,1.05L2.8,10l4.725,4.725a.725.725,0,0,1,0,1.05A.681.681,0,0,1,7,16Z"
            transform="translate(7.75 16) rotate(180)"
          />
        </g>
      );

    case "ico-delete":
      return (
        <g transform="translate(-1277 -707.7)">
          <path
            {...props}
            d="M1283,719.7a6,6,0,1,1,6-6A6.018,6.018,0,0,1,1283,719.7Zm0-10.7a4.7,4.7,0,1,0,4.7,4.7h0A4.7,4.7,0,0,0,1283,709Z"
          />
          <g id="Group_3655" data-name="Group 3655">
            <path
              {...props}
              d="M1285.3,715.8a.52.52,0,0,1-.2.4.758.758,0,0,1-.4.2.55.55,0,0,1-.5-.3l-1.2-1.5-1.2,1.5-.2.2c-.1,0-.2.1-.3.1a.758.758,0,0,1-.4-.2.52.52,0,0,1-.2-.4.6.6,0,0,1,.1-.4l1.4-1.7-1.4-1.8c-.1-.1-.1-.2-.1-.4a.52.52,0,0,1,.2-.4.758.758,0,0,1,.4-.2.55.55,0,0,1,.5.3l1.2,1.5,1.1-1.5a.55.55,0,0,1,.5-.3.707.707,0,0,1,.6.6.6.6,0,0,1-.1.4l-1.4,1.7,1.4,1.8A.52.52,0,0,1,1285.3,715.8Z"
            />
          </g>
        </g>
      );

    case "rating":
      return (
        <g>
          <path
            {...props}
            d="M5.427,18.441a1.4,1.4,0,0,1-1.374-1.664l.776-4.349-3.2-3.077a1.4,1.4,0,0,1,.792-2.4l4.38-.6L8.739,2.354A1.39,1.39,0,0,1,9.4,1.691a1.409,1.409,0,0,1,1.865.67L13.2,6.345l4.391.605a1.4,1.4,0,0,1,.774,2.407l-3.185,3.07.779,4.361A1.4,1.4,0,0,1,13.9,18.269L10,16.188,6.092,18.273A1.38,1.38,0,0,1,5.427,18.441ZM10,14.375l4.307,2.3-.859-4.8L16.966,8.48,12.13,7.813,10,3.417,7.87,7.813,3.034,8.48l3.52,3.387-.858,4.8Z"
          />
        </g>
      );

    case "affiliate":
      return (
        <g>
          <path
            {...props}
            d="M17.1 8.648a.568 .568 0 0 1 -.761 .011a5.682 5.682 0 0 0 -3.659 -1.34c-1.102 0 -2.205 .363 -2.205 1.374c0 1.023 1.182 1.364 2.546 1.875c2.386 .796 4.363 1.796 4.363 4.137c0 2.545 -1.977 4.295 -5.204 4.488l-.295 1.364a.557 .557 0 0 1 -.546 .443h-2.034l-.102 -.011a.568 .568 0 0 1 -.432 -.67l.318 -1.444a7.432 7.432 0 0 1 -3.273 -1.784v-.011a.545 .545 0 0 1 0 -.773l1.137 -1.102c.214 -.2 .547 -.2 .761 0a5.495 5.495 0 0 0 3.852 1.5c1.478 0 2.466 -.625 2.466 -1.614c0 -.989 -1 -1.25 -2.886 -1.954c-2 -.716 -3.898 -1.728 -3.898 -4.091c0 -2.75 2.284 -4.091 4.989 -4.216l.284 -1.398a.545 .545 0 0 1 .545 -.432h2.023l.114 .012a.544 .544 0 0 1 .42 .647l-.307 1.557a8.528 8.528 0 0 1 2.818 1.58l.023 .022c.216 .228 .216 .569 0 .773l-1.057 1.057z"
          ></path>
        </g>
      );

    case "content":
      return (
        <g>
          <path
            {...props}
            d="M15.7477 0.0900879C19.5831 0.0900879 22.1595 2.71653 22.1595 6.62509V17.8433C22.1595 21.786 19.6623 24.3502 15.7977 24.3746L6.41301 24.3783C2.57765 24.3783 0 21.7519 0 17.8433V6.62509C0 2.68116 2.49714 0.118146 6.36178 0.0949675L15.7465 0.0900879H15.7477ZM15.7477 1.91994L6.36788 1.92482C3.52795 1.9419 1.82985 3.69855 1.82985 6.62509V17.8433C1.82985 20.7894 3.54381 22.5484 6.41179 22.5484L15.7916 22.5448C18.6315 22.5277 20.3296 20.7686 20.3296 17.8433V6.62509C20.3296 3.67903 18.6169 1.91994 15.7477 1.91994ZM15.5124 16.5267C16.0174 16.5267 16.4273 16.9365 16.4273 17.4416C16.4273 17.9466 16.0174 18.3565 15.5124 18.3565H6.70469C6.19965 18.3565 5.78977 17.9466 5.78977 17.4416C5.78977 16.9365 6.19965 16.5267 6.70469 16.5267H15.5124ZM15.5124 11.4195C16.0174 11.4195 16.4273 11.8294 16.4273 12.3345C16.4273 12.8395 16.0174 13.2494 15.5124 13.2494H6.70469C6.19965 13.2494 5.78977 12.8395 5.78977 12.3345C5.78977 11.8294 6.19965 11.4195 6.70469 11.4195H15.5124ZM10.0652 6.32426C10.5702 6.32426 10.9801 6.73415 10.9801 7.23919C10.9801 7.74423 10.5702 8.15411 10.0652 8.15411H6.70433C6.19929 8.15411 5.7894 7.74423 5.7894 7.23919C5.7894 6.73415 6.19929 6.32426 6.70433 6.32426H10.0652Z"
          />
        </g>
      );
    case "report":
      return (
        <g>
          <path
            {...props}
            d="M16.8 3.6C16.8 3.28174 16.9264 2.97652 17.1515 2.75147C17.3765 2.52643 17.6817 2.4 18 2.4H34.8C35.1183 2.4 35.4235 2.52643 35.6485 2.75147C35.8736 2.97652 36 3.28174 36 3.6V6C36 6.31826 35.8736 6.62348 35.6485 6.84853C35.4235 7.07357 35.1183 7.2 34.8 7.2H18C17.6817 7.2 17.3765 7.07357 17.1515 6.84853C16.9264 6.62348 16.8 6.31826 16.8 6V3.6ZM4.8 0C3.52696 0 2.30606 0.505713 1.40589 1.40589C0.505713 2.30606 0 3.52696 0 4.8L0 9.6C0 10.873 0.505713 12.0939 1.40589 12.9941C2.30606 13.8943 3.52696 14.4 4.8 14.4H9.6C10.873 14.4 12.0939 13.8943 12.9941 12.9941C13.8943 12.0939 14.4 10.873 14.4 9.6V4.8C14.4 3.52696 13.8943 2.30606 12.9941 1.40589C12.0939 0.505713 10.873 0 9.6 0H4.8ZM4.8 19.2C3.52696 19.2 2.30606 19.7057 1.40589 20.6059C0.505713 21.5061 0 22.727 0 24L0 28.8C0 30.073 0.505713 31.2939 1.40589 32.1941C2.30606 33.0943 3.52696 33.6 4.8 33.6H9.6C10.873 33.6 12.0939 33.0943 12.9941 32.1941C13.8943 31.2939 14.4 30.073 14.4 28.8V24C14.4 22.727 13.8943 21.5061 12.9941 20.6059C12.0939 19.7057 10.873 19.2 9.6 19.2H4.8ZM6.8496 10.4496C6.73813 10.5614 6.60571 10.65 6.45992 10.7105C6.31413 10.771 6.15784 10.8021 6 10.8021C5.84216 10.8021 5.68587 10.771 5.54008 10.7105C5.39429 10.65 5.26187 10.5614 5.1504 10.4496L2.7504 8.0496C2.63883 7.93803 2.55033 7.80557 2.48994 7.6598C2.42956 7.51403 2.39848 7.35778 2.39848 7.2C2.39848 7.04221 2.42956 6.88597 2.48994 6.7402C2.55033 6.59442 2.63883 6.46197 2.7504 6.3504C2.86197 6.23883 2.99443 6.15033 3.1402 6.08994C3.28597 6.02956 3.44221 5.99848 3.6 5.99848C3.75779 5.99848 3.91403 6.02956 4.0598 6.08994C4.20557 6.15033 4.33803 6.23883 4.4496 6.3504L6 7.9032L9.9504 3.9504C10.062 3.83883 10.1944 3.75033 10.3402 3.68994C10.486 3.62956 10.6422 3.59848 10.8 3.59848C10.9578 3.59848 11.114 3.62956 11.2598 3.68994C11.4056 3.75033 11.538 3.83883 11.6496 3.9504C11.7612 4.06197 11.8497 4.19443 11.9101 4.3402C11.9704 4.48597 12.0015 4.64221 12.0015 4.8C12.0015 4.95779 11.9704 5.11403 11.9101 5.2598C11.8497 5.40557 11.7612 5.53803 11.6496 5.6496L6.8496 10.4496ZM6.8496 29.6496C6.73813 29.7614 6.60571 29.85 6.45992 29.9105C6.31413 29.971 6.15784 30.0021 6 30.0021C5.84216 30.0021 5.68587 29.971 5.54008 29.9105C5.39429 29.85 5.26187 29.7614 5.1504 29.6496L2.7504 27.2496C2.52507 27.0243 2.39848 26.7187 2.39848 26.4C2.39848 26.0813 2.52507 25.7757 2.7504 25.5504C2.97573 25.3251 3.28134 25.1985 3.6 25.1985C3.91866 25.1985 4.22427 25.3251 4.4496 25.5504L6 27.1032L9.9504 23.1504C10.1757 22.9251 10.4813 22.7985 10.8 22.7985C11.1187 22.7985 11.4243 22.9251 11.6496 23.1504C11.8749 23.3757 12.0015 23.6813 12.0015 24C12.0015 24.3187 11.8749 24.6243 11.6496 24.8496L6.8496 29.6496ZM16.8 22.8C16.8 22.4817 16.9264 22.1765 17.1515 21.9515C17.3765 21.7264 17.6817 21.6 18 21.6H34.8C35.1183 21.6 35.4235 21.7264 35.6485 21.9515C35.8736 22.1765 36 22.4817 36 22.8V25.2C36 25.5183 35.8736 25.8235 35.6485 26.0485C35.4235 26.2736 35.1183 26.4 34.8 26.4H18C17.6817 26.4 17.3765 26.2736 17.1515 26.0485C16.9264 25.8235 16.8 25.5183 16.8 25.2V22.8ZM16.8 10.8C16.8 10.4817 16.9264 10.1765 17.1515 9.95147C17.3765 9.72643 17.6817 9.6 18 9.6H30C30.3183 9.6 30.6235 9.72643 30.8485 9.95147C31.0736 10.1765 31.2 10.4817 31.2 10.8C31.2 11.1183 31.0736 11.4235 30.8485 11.6485C30.6235 11.8736 30.3183 12 30 12H18C17.6817 12 17.3765 11.8736 17.1515 11.6485C16.9264 11.4235 16.8 11.1183 16.8 10.8ZM16.8 30C16.8 29.6817 16.9264 29.3765 17.1515 29.1515C17.3765 28.9264 17.6817 28.8 18 28.8H30C30.3183 28.8 30.6235 28.9264 30.8485 29.1515C31.0736 29.3765 31.2 29.6817 31.2 30C31.2 30.3183 31.0736 30.6235 30.8485 30.8485C30.6235 31.0736 30.3183 31.2 30 31.2H18C17.6817 31.2 17.3765 31.0736 17.1515 30.8485C16.9264 30.6235 16.8 30.3183 16.8 30Z"
          />
        </g>
      );
    default:
      return <path />;
  }
};

const IconsLingo = ({
  name = "",
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "",
  height = "100%",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox || getViewBox(name)}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {getPath(name, { fill })}
  </svg>
);

IconsLingo.propTypes = {
  name: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  style: PropTypes.object,
};

export default IconsLingo;
